/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AvatarsRpc
 */
import * as References from './AvatarsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AvatarsRpc#getAvatarsBulk
 */
export const GET_AVATARS_BULK_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AvatarsRpc_getAvatarsBulk';
export const GET_AVATARS_BULK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AVATARS_BULK_QUERY_FIELD_NAME,
  args: ['entities', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAvatarsBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});